import { DataTableColumn } from '../../Base/Components/DataTable/DataTable';
import { CareClaimsQuery } from '../../../graphql/graphql';
import React from 'react';
import FormattedDate from '../../../Components/FormattedDate';
import { DocumentContentSubType } from '../../Documents/Enums/documentContentSubType.enum';
import { Theme } from '../../../Enums/Theme.enum';
import LinkButton from '../../../Components/Button/LinkButton';
import NetteApiClient from '../../../Services/NetteApiClient';
import ManagerInsuranceCompaniesCareClaimDelete from '../Components/ManagerWrapper/InsuranceCompanies/ManagerInsuranceCompaniesCareClaimDeleteModal/ManagerInsuranceCompaniesCareClaimDelete';
import { QueryDataItem } from '../../../Interfaces/QueryDataItem';

export type CareClaim = QueryDataItem<CareClaimsQuery['careClaims']>;

export interface CareClaimsTable {
	refresh: () => void;
}

export const CareClaimDefaultColumns: DataTableColumn<
	CareClaim,
	CareClaimsTable
>[] = [
	{
		key: 'code',
		label: 'component.reportedCare.tableCode',
		bold: true,
		renderItem: (item: CareClaim) => (
			<span>{item?.medicalProcedure?.code || ''}</span>
		),
	},
	{
		key: 'name',
		label: 'component.reportedCare.tableName',
		renderItem: (item: CareClaim) => (
			<span>{item?.medicalProcedure?.name || ''}</span>
		),
	},
	{
		key: 'executedAt',
		label: 'component.reportedCare.tableExecutedAt',
		renderItem: (item: CareClaim) => {
			const documentItems = item?.document?.items ?? [];
			const claimedAt = documentItems.find(item => item?.type === 'datetime');

			const datetime = claimedAt?.extra?.text || item?.document?.createdAt;
			return datetime ? <FormattedDate date={datetime} /> : <span></span>;
		},
	},
	{
		key: 'mainDiagnosis',
		label: 'component.reportedCare.tableMainDiagnosis',
		renderItem: (item: CareClaim) => {
			const documentItems = item?.document?.items ?? [];
			const mainDiagnosis = documentItems.find(
				item => item?.extra?.subType === DocumentContentSubType.MAIN_DIAGNOSIS,
			);
			return (
				<span>
					{mainDiagnosis?.extra?.text?.value ||
						mainDiagnosis?.extra?.text?.label ||
						''}
				</span>
			);
		},
	},
	{
		key: 'documentType',
		label: 'component.reportedCare.tableDocumentType',
		renderItem: (item: CareClaim) => <span>{item?.documentType || ''}</span>,
	},
	{
		key: 'patient',
		label: 'component.reportedCare.patient',
		bold: true,
		renderItem: (item: CareClaim) => (
			<span>
				{item?.document?.user?.workplacePatient?.profile?.fullName || ''}
			</span>
		),
	},
	{
		key: 'registration',
		label: 'component.reportedCare.registration',
		renderItem: (item: CareClaim) =>
			item?.registered && <FormattedDate date={item.registered} />,
	},
	{
		key: 'insuranceCompany',
		label: 'component.reportedCare.insuranceCompany',
		renderItem: (item: CareClaim) => (
			<span>{item?.insuranceCompany?.value2 || ''}</span>
		),
	},
	{
		key: 'doctor',
		label: 'component.reportedCare.doctor',
		bold: true,
		renderItem: (item: CareClaim) => (
			<span>{item?.createdBy?.details?.fullName || ''}</span>
		),
	},
	{
		key: 'edit',
		label: 'component.reportedCare.tableEdit',
		renderItem: (item: CareClaim) => (
			<LinkButton
				title='base.shared.edit'
				theme={Theme.BLUE}
				onClick={() => {
					const patientId = item?.document?.user?.workplacePatient?.id;
					NetteApiClient.get(`/profil-pacienta/${patientId}?handle=treatment`);
				}}
			/>
		),
	},
	{
		key: 'remove',
		label: 'component.reportedCare.tableRemove',
		renderItem: (item: CareClaim, { refresh }: CareClaimsTable) => (
			<ManagerInsuranceCompaniesCareClaimDelete
				item={item}
				reloadData={refresh}
			/>
		),
	},
];
